@if((deskmode() !=='xs' && deskmode() !=='sm')) {
<header class="header">
    <ng-container *ngTemplateOutlet="navcontent"></ng-container>
</header>
} @else {
<ng-container *ngTemplateOutlet="mobileMode"></ng-container>
}

<ng-template #mobileMode>
    <div class="headermob">
        <ng-container *ngTemplateOutlet="mobilelogo"></ng-container>

        <div style="display: flex;align-items: center;">
            <!-- <a  multilang href="tel:{{partner?.tel}}" aria-label="phone" class="headerbtn cc10">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                            d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                    </svg>
                </a> -->
            @if(partner && !partner?.hideSearch) {
            <button class="headerbtn" aria-label="search" (click)="showsearch = !showsearch;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                </svg>
            </button>
            }
            @if(partner && !partner?.hideLogin) {
            <button class="headerbtn" aria-label="login" (click)="gotoPartner()">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
            </button>
            }
            <mat-menu #custmenu="matMenu">
                <button mat-menu-item (click)="logout()">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                        fill="currentColor">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                            d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                    </svg> Logout
                </button>
            </mat-menu>

            <button [disabled]="favoritesCount === 0" aria-label="favorite"
                [matBadge]="favoritesCount > 0 ? favoritesCount : ''" matBadgePosition="before" matBadgeColor="warn"
                (click)="gotofavorites()" class="headerbtn">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                </svg>
            </button>

            @if(partner?.multilangualktiv) {
            <button [matMenuTriggerFor]="langmenu" aria-label="menu" class="cc8" matRipple>
                <span multilang>{{i18nService.langUp}}</span>
            </button>
            <mat-menu #langmenu="matMenu">
                <button mat-menu-item (click)="changeLng('de')" aria-label="de" matRipple>
                    DE
                </button>
                <button mat-menu-item (click)="changeLng('fr')" aria-label="fr" matRipple>
                    FR
                </button>
                <button mat-menu-item (click)="changeLng('nl')" aria-label="nl" matRipple>
                    NL
                </button>
            </mat-menu>
            }

            <button aria-label="menu" class="headerbtn cc9" (click)="openMenu($event)">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                </svg>
            </button>
        </div>
    </div>
    @if(showsearch && partner && !partner?.hideSearch) {
    <clever-headersearch></clever-headersearch>
    }
</ng-template>

<ng-template #mobilelogo>
    <div>
        <button class="logo-a-mobile" (click)="gotohome()">
            <ng-container *ngIf="logo?.length > 0">
                <img class="lazyload logo-img-mobile" src="{{logo}}" alt="{{partner?.firmenname}} logo">
            </ng-container>
            <ng-container *ngIf="!(partner?.noname)">
                <span multilang
                    *ngIf="partnername?.length > 0 && partner?.partnerid !== 'main' && partner?.partnerid !== 'reisen'"
                    class="pnamew pp-mobile">{{partner?.partnerid === 'main' ? '' : partnername}}</span>
            </ng-container>
        </button>
    </div>
</ng-template>

<ng-template #navcontent>
    <div class="subheaderwrapper">
        <div class="logowrapper">
            <div class="ml5">
                <button class="logo-a" (click)="gotohome()">
                    <ng-container *ngIf="logo?.length > 0">
                        <img class="lazyload a-img" src="{{logo}}" height="36" width="auto"
                            alt="{{partner?.firmenname}} logo">
                    </ng-container>
                    <ng-container *ngIf="!(partner?.noname)">
                        <span multilang class="pnamew">{{partner?.partnerid === 'main' ? '' :
                            partnername}}</span>
                    </ng-container>
                </button>
            </div>
        </div>
        @if(partner && !partner?.hideSearch) {
        <clever-headersearch></clever-headersearch>
        }
        <div class="headerwrapper mr5">
            <ng-container *ngTemplateOutlet="subnavcontent"></ng-container>
        </div>
    </div>
    <div class="tmp_right-wrapper">
        <div class="tmp_mnwrp">
            <div class="dflx ml5">
                <clever-menu2 [deskmode]="deskmode()" [mobile]="mobile" [showChat]="!partner?.hideChat"
                    [showTermin]="!partner?.hideTermin" [showhReisekompass]="!partner?.hideReisekompass"
                    [showhLogin]="!partner?.hideLogin" [showhDigbrater]="!partner?.hideDigbrater"></clever-menu2>
            </div>
            <div class="dflx mr5">
                <ng-container *ngIf="currentCustomer?.asPartner">
                    <app-chatampel></app-chatampel>
                </ng-container>
                @if(partner && !partner?.hideDigbrater) {
                <button (click)="gotoAnfrage()" class="subheaderbtn" aria-label="Digitaler Reiseberater"
                    matTooltip="Digitaler Reiseberater" matRipple>
                    <mat-icon fontIcon="smart_toy"></mat-icon>
                </button>
                }
                @if(partner && !partner?.hideReisekompass) {
                <button (click)="gotoContent()" class="subheaderbtn" aria-label="Reisekompass" matTooltip="Reisekompass"
                    matRipple>
                    <mat-icon fontIcon="explore"></mat-icon>
                </button>
                }
                <button (click)="gotofavorites()" [matBadge]="favoritesCount > 0 ? favoritesCount : ''"
                    matBadgeOverlap="false" matTooltip="Favoriten" aria-label="favorite" matBadgeSize="small"
                    matBadgePosition="above after" matBadgeColor="warn" class="subheaderbtn" matRipple>
                    <mat-icon fontIcon="favorite"></mat-icon>
                </button>
                @if(currentCustomer?.asPartner) {
                <button (click)="gotoOfferpack()" [matBadge]="offerpackCount > 0 ? offerpackCount : ''"
                    matBadgeOverlap="false" matTooltip="Angebotsliste" matBadgeSize="small"
                    matBadgePosition="above after" matBadgeColor="warn" class="subheaderbtn" matRipple>
                    <mat-icon fontIcon="local_offer"></mat-icon>
                </button>
                }
            </div>
        </div>
    </div>
</ng-template>

<ng-template #subnavcontent>
    <div class="submenuwrapper">
        @if(!partner?.hideTel) {
        <a multilang class="afon" href="tel:{{partner?.tel}}" (mouseover)="fixsetoultip=true"
            (mouseleave)="fixsetoultip=false" #trigertooltip="cdkOverlayOrigin" cdkOverlayOrigin>
            <span multilang>{{partner?.tel}}</span>
        </a>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigertooltip"
            [cdkConnectedOverlayOpen]="fixsetoultip">
            <div class="cc17 mat-elevation-z1">
                <div class="cc19">
                    <b>{{partner?.tel}}</b><br>
                    @if(partner?.opening_period?.length > 0) {
                    <span multilang class="mt1 cc20">{{partner?.opening_period}}</span>
                    } @else {
                    <span multilang>Beratung & Buchung täglich von</span><br>
                    <span multilang class="mt1 cc20">{{'08 - 23 Uhr'}}</span>
                    }
                </div>
            </div>
        </ng-template>
        }
        @if(!partner?.hideTermin) {
        <button class="headerbtn" matTooltip="Termin" aria-label="Termin" (click)="gotoCalendar()">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z" />
            </svg>
        </button>
        }
        @if(!partner?.hideChat) {
        <button class="headerbtn" matTooltip="Chat" aria-label="Chat" (click)="openChat()">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" />
            </svg>
        </button>
        }
        @if(partner && !partner?.hideLogin) {
        @if(currentCustomer?.email?.length > 0) {

        <button [matMenuTriggerFor]="custmenu" [matTooltip]="currentCustomer?.firstname ? currentCustomer.firstname + ' ' + currentCustomer.lastname :
                                'Mein Konto'" class="headerbtn" matRipple>
            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24"
                width="24px" fill="currentColor">
                <g>
                    <rect fill="none" height="24" width="24" />
                </g>
                <g>
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z" />
                </g>
            </svg>
        </button>
        <mat-menu #custmenu="matMenu">
            <button mat-menu-item (click)="logout()" aria-label="Logout" matRipple>
                <mat-icon>exit_to_app</mat-icon> Logout
            </button>
        </mat-menu>
        }@else {
        <ng-container *ngTemplateOutlet="anmelden"></ng-container>
        }
        <ng-template #anmelden>
            <button class="headerbtn" matTooltip="Anmelden" aria-label="Anmelden" (click)="gotoPartner()">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
            </button>
        </ng-template>
        }

        @if(partner?.multilangualktiv) {
        <button [matMenuTriggerFor]="langmenu" aria-label="menu" class="cc8" matRipple>
            <span>{{i18nService.langUp}}</span>
        </button>
        <mat-menu #langmenu="matMenu">
            <button mat-menu-item (click)="changeLng('de')" aria-label="de" matRipple>
                DE
            </button>
            <button mat-menu-item (click)="changeLng('fr')" aria-label="fr" matRipple>
                FR
            </button>
            <button mat-menu-item (click)="changeLng('nl')" aria-label="nl" matRipple>
                NL
            </button>
        </mat-menu>
        }

    </div>
</ng-template>


<ng-container *ngIf="mobile">
    <div class="sidenav-overlay" [class.hidden]="!menuactive" (click)="closeMenu($event)">
        <div id="mySidenav" class="sidenav noselect customscroll" [class.leftmnu]="desktopTemplate"
            [class.rightmnu]="!desktopTemplate" [class.w100]="mobile">
            <clever-menu2 class="w100" [mobile]="true" [showChat]="!partner?.hideChat"
                [showTermin]="!partner?.hideTermin" [showhReisekompass]="!partner?.hideReisekompass"
                [showhLogin]="!partner?.hideLogin" [showhDigbrater]="!partner?.hideDigbrater"></clever-menu2>
        </div>
    </div>
</ng-container>